<template>
  <div id="content">
    <HeaderBanner :heading="$t('PAGE_NOT_FOUND.HEADING_BANNER')" />
    <div class="intro-box" id="page-not-found">
      <v-container>
        <p class="teaser">{{ $t('PAGE_NOT_FOUND.HEADING_SUB') }}</p>
        <p class="heading">{{ $t('PAGE_NOT_FOUND.HEADING') }}</p>
        <v-row>
          <v-col class="description" cols="12" md="6">
            <p>{{ $t('PAGE_NOT_FOUND.DESCRIPTION.0') }}</p>
            <v-btn class="btn-cta" :flat="true" @click="$router.push('/')">{{ $t('PAGE_NOT_FOUND.BUTTON_TO_HOME') }}</v-btn>
          </v-col>
          <v-col class="icon mt-16 mt-md-0" cols="12" md="6">
            <v-icon icon="fal fa-exclamation-circle" />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import HeaderBanner from '@/components/page/header/Banner.vue';

  export default defineComponent({
    name: 'PageNotFound',
    components: {
      HeaderBanner,
    },
    setup() {
      return {};
    },
  });
</script>

<style lang="scss" scoped>
  @import '@/scss/configs/colors';
  @import '@/scss/configs/fonts';

  #page-not-found {
    .icon {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      padding-top: 0;
      padding-bottom: 0;

      .v-icon {
        width: 200px;
        height: 200px;
        color: $color-blue-grey-20;
      }
    }
  }
</style>
